import { FILTER_TYPES, PAGE_SIZE_FILTER } from 'constants/filterType';
import {
  INVENTORY_TYPE,
  INVENTORY_HISTORY_METHOD,
  INVENTORY_CONTEXT,
} from 'constants/inventory';

export const INVENTORY_FILTER_OPTIONS = [
  {
    field: 'inventory_type',
    label: 'Inventory Category',
    type: FILTER_TYPES.SELECT,
    options: INVENTORY_TYPE,
  },
  {
    field: 'product_sku__icontains',
    label: 'Product SKU',
    type: FILTER_TYPES.TEXT,
  },
  {
    field: 'product_sku',
    label: 'Product SKUs',
    type: FILTER_TYPES.MULTI_TEXT,
  },
  {
    field: 'product_name__icontains',
    label: 'Product Name',
    type: FILTER_TYPES.TEXT,
  },
  {
    field: 'brand_name__icontains',
    label: 'Brand Name',
    type: FILTER_TYPES.TEXT,
  },
  {
    field: 'shelf_code__icontains',
    label: 'Shelf Code',
    type: FILTER_TYPES.TEXT,
  },
  {
    field: 'expire_date_after',
    label: 'Expiry Date After',
    type: FILTER_TYPES.DATE,
  },
  {
    field: 'expire_date_before',
    label: 'Expiry Date Before',
    type: FILTER_TYPES.DATE,
  },
  {
    field: 'batch_code__icontains',
    label: 'Batch Code',
    type: FILTER_TYPES.TEXT,
  },
  {
    field: 'modified_after',
    label: 'Updated After',
    type: FILTER_TYPES.DATE,
  },
  {
    field: 'modified_before',
    label: 'Updated Before',
    type: FILTER_TYPES.DATE,
  },
  { ...PAGE_SIZE_FILTER },
];

export const INVENTORY_HISTORY_FILTER_OPTIONS = [
  {
    field: 'inventory_type',
    label: 'Inventory Category',
    type: FILTER_TYPES.SELECT,
    options: INVENTORY_TYPE,
  },
  {
    field: 'inventory_history_method',
    label: 'Type',
    type: FILTER_TYPES.MULTI_SELECT,
    options: INVENTORY_HISTORY_METHOD,
  },
  {
    field: 'context',
    label: 'Context',
    type: FILTER_TYPES.SELECT,
    options: INVENTORY_CONTEXT,
  },
  {
    field: 'product_sku__icontains',
    label: 'Product SKU',
    type: FILTER_TYPES.TEXT,
  },
  {
    field: 'product_sku',
    label: 'Product SKUs',
    type: FILTER_TYPES.MULTI_TEXT,
  },
  {
    field: 'brand_name__icontains',
    label: 'Brand Name',
    type: FILTER_TYPES.TEXT,
  },
  {
    field: 'email__icontains',
    label: 'Adjusted By',
    type: FILTER_TYPES.TEXT,
  },
  {
    field: 'created_after',
    label: 'Created After',
    type: FILTER_TYPES.DATE,
  },
  {
    field: 'created_before',
    label: 'Created Before',
    type: FILTER_TYPES.DATE,
  },
  { ...PAGE_SIZE_FILTER },
];
